
import * as React from 'react'
import {CSSProperties} from 'react';
import {MajorAccountsHdr} from '../Components/MajorAccountsHdr';
import * as Tgcc from '../tgccGlobal';
import {MajorAccountsFooter} from '../Components/MajorAccountsFooter';
import Radium, { StyleRoot } from 'radium';
import * as Request from '../tgccRequest';
import {Message} from '../Components/Message';
import {browserHistory} from 'react-router';



const feedbackDiv: CSSProperties = {
    display:'flex',
    flexDirection:'column',
    width:'30%',
    margin:'10% auto',    
}
const pageDiv: CSSProperties = {
    backgroundColor:"rgb(247,245,240)"
}
const btn : CSSProperties = {
    border: "1px solid transparent",
    backgroundColor: "rgb(226, 117, 88)",
    height: '40px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0px 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px auto',
    width: '142px',
    fontFamily: 'Lulo'
}
const label: CSSProperties = {
    fontFamily:"BarlowMedium",
    color:'rgb(166, 166, 166)'
}
const hdr: CSSProperties = {
    textAlign: 'center',
    position: 'relative',
    top: '125px',
    fontFamily: 'BarlowMedium',
    color: 'rgb(166, 166, 166)',
    fontSize:'20px'
}
const subH: CSSProperties = {
    textAlign: 'center',
    position: 'relative',
    top: '140px',
    fontFamily: 'BarlowLight',
    color: 'rgb(166, 166, 166)',
    fontSize:'20px'
}
const textarea: CSSProperties = {
    height:'150px',
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"BarlowMedium",
    color: 'rgb(166, 166, 166)',
    fontSize:"16px",
    letterSpacing:'1px'
}
const style: CSSProperties = {
    border:'1px solid rgb(166, 166, 166)',
    fontFamily:"BarlowMedium",
    color: 'rgb(166, 166, 166)'
}
const errStyle: CSSProperties = {
    color:'red',
    textAlign:'center',
    position:"relative",
    top:'145px',
    fontSize:'15px'
}

class _MajorAccountsFeedback extends React.Component<Tgcc.BaseProps,any> {
    state = {
        name:null,
        email:null,
        message:null,
        finished:false,
        error:'',
        isWaiting: false,
    }
    componentDidMount(){
        var tag = document.getElementById('feedback');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }
    handleNameChange = (evt: React.FormEvent<HTMLInputElement>) =>{
        this.setState({name:evt.currentTarget.value});
    }
    handleEmailChange = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({email:evt.currentTarget.value});
    }
    handleMessageChange = (evt:React.FormEvent<HTMLTextAreaElement>) => {
        this.setState({message:evt.currentTarget.value});
    }
    sendMessage = () => {       
        if(!this.state.name){
            this.setState({error:"Please provide your name."})
        } else if(!this.state.email){
            this.setState({error:"Please provide your email address."})
        } else if(!this.state.message){
            this.setState({error:"Please provide a message."})
        }else {
            this.setState({isWaiting:true});
            var feedback = new Tgcc.Feedback;
            feedback.name = this.state.name;
            feedback.email = this.state.email;
            feedback.message = this.state.message;
            feedback.timestamp = new Date().toLocaleString();
            Request.sendFeedback(feedback,this.finished)
        }
    }
    finished = () => {
        this.setState({finished:true});
    }
    whenFinished = () => {
        browserHistory.push(Tgcc.Routes.Home);
    }
    getThankYou = () => {
        return <Message 
            Title="Thank You!"         
            UseTitleScript={true}
            Message1="We appreciate your feedback!"
            onContinue={this.whenFinished}
        />
    }
    render () {
        var thankYou = this.state.finished ? this.getThankYou() : null;
        var waiting = this.state.isWaiting ? Tgcc.workingGif: <div style={btn} onClick={this.sendMessage}>Submit</div>
        return (
              <div style={pageDiv}>
              <div id="feedback"></div> 
                    <MajorAccountsHdr />
                    <div style={hdr}>We are always looking to improve our customers experience.</div>
                    <div style={subH}>Let us know what you think!</div>
                    <div style={errStyle}>{this.state.error}</div>
                    <div style={feedbackDiv} className='feedbackDiv'>
                        <label htmlFor="Name" style={label}>Name:</label>
                        <input style={style} type="text" name="name" onChange={this.handleNameChange}/>
                        <label htmlFor="email" style={label}>Email:</label>
                        <input style={style} type="text" name="email" onChange={this.handleEmailChange}/>
                        <label htmlFor="message" style={label}>Message:</label>
                        <textarea style={textarea} type="text" name="message" onChange={this.handleMessageChange}/> 
                        {waiting}
                    </div>
                      {thankYou}
                        <MajorAccountsFooter  state={this.props.state} />
                    </div>
        )
    }
}

export var MajorAccountsFeedback = Radium(_MajorAccountsFeedback);